import { slab, wallX, goal, sign, checkpoint, edgeLights, shatter, boost } from '../kit.js';

/**
 * CHAPTER 2, SECTOR 14: FRACTURE. Glass momentum. Every pane prints its
 * threshold; boost strips feed the speed that breaks them. Three chapters:
 * the teach, the branch (fast glass needs strips, slow glass breaks at a
 * jog), and the drop stack where the floors themselves are panes and
 * falling is the speed source. Laws honored: contiguous floors under every
 * pane (no gap traps), catch decks sized for both hop phases, killY under
 * the drop only.
 */
export default {
  id: 'fracture',
  name: 'FRACTURE',
  blurb: 'The glass remembers how fast you were.',
  mode: { type: 'sprint', par: 75 },
  redline: { seconds: 30 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 9], yaw: 0 },
  killY: -60,
  unlockAfter: 'conflux',
  env: {
    fog: 0x0c1420,
    fogDensity: 0.0042,
    sky: { zenith: 0x04080f, horizon: 0x10202e, glow: 0x2a5a7a, aurora: 0x6fd8ff },
    floorY: -320,
  },
  objects: [
    // ---- chapter 1: the teach. One strip, one pane, one lesson.
    slab(0, 0, 0, 20, 26, 'panel', 1.4),
    ...edgeLights(0, 0, 0, 20, 26, 'cyan'),
    boost(0, 0, -6, 5, 12, [0, 0, -1], 32, 34),
    shatter(0, 2.5, -13, [12, 5, 0.4], 18),
    slab(0, 0, -24, 20, 22, 'panel', 1.4),
    checkpoint(0, 0, -30),
    sign(0, 3.2, 4, 0, ['FRACTURE', 'THE STRIP FEEDS THE GLASS', '18 M/S BREAKS IT']),
    sign(6, 2.6, -28, 0, ['COURIER LOG 01', 'THE GLASS REMEMBERS', 'HOW FAST YOU WERE'], '#9fd8ff'),

    // ---- chapter 2: the branch. Left lane: strip-fed panes at 26. Right
    // lane: no strips, panes a jog can break. Same destination.
    wallX(0, 0, -55, 40, 6, 'panel', 1.0),
    wallX(-10.35, 0, -55, 40, 5, 'plate', 1.4),
    wallX(10.35, 0, -55, 40, 5, 'plate', 1.4),
    slab(-5.5, 0, -55, 9, 40, 'panel', 1.4),
    boost(-5.5, 0, -41, 4, 12, [0, 0, -1], 40, 40),
    shatter(-5.5, 2.5, -48, [9, 5, 0.4], 22),
    boost(-5.5, 0, -57, 4, 12, [0, 0, -1], 40, 40),
    shatter(-5.5, 2.5, -64, [9, 5, 0.4], 22),
    slab(5.5, 0, -55, 9, 40, 'panel', 1.4),
    shatter(5.5, 2.5, -48, [9, 5, 0.4], 6),
    shatter(5.5, 2.5, -64, [9, 5, 0.4], 6),
    sign(-5.5, 3.4, -37, 0, ['FAST GLASS', 'HOLD THE STRIPS'], '#2ff3ff'),
    sign(5.5, 3.4, -37, 0, ['SLOW GLASS', 'A JOG WILL DO'], '#ffb020'),
    slab(0, 0, -84, 22, 18, 'panel', 1.4),
    ...edgeLights(0, 0, -84, 22, 18, 'cyan'),
    checkpoint(0, 0, -88),

    // ---- chapter 3: the drop stack. The panes are floors; gravity is the
    // strip. Threshold rises with the fall speed math (8m = 20 m/s).
    slab(0, 0, -100, 22, 14, 'panel', 1.4),
    checkpoint(0, 0, -98),
    sign(0, 2.6, -103, 0, ['THE DROP', 'THE FLOORS ARE GLASS', 'FALL FASTER'], '#9fd8ff'),
    shatter(0, -8, -113, [12, 0.4, 12], 12),
    shatter(0, -18, -113, [12, 0.4, 12], 18),
    shatter(0, -28, -113, [12, 0.4, 12], 25),
    slab(0, -40, -113, 26, 26, 'panel', 1.5),
    ...edgeLights(0, -40, -113, 26, 26, 'lime'),
    // The drop lands at ~z -120 (7.6 m/s carry over a 1.75s fall); the
    // goal sits just past the landing line so the fall delivers you to it.
    goal(0, -40, -122, 0),
  ],
};
